<h2 class="modal-title text-center animated fadeInDown">{{ stepTitle() }}</h2>

@switch (currentStep()) {

@case (stepTypes.WELCOME) {
<app-welcome-message [modalContentData]="modalContentData" [embedded]="true" [hasNextStep]="!isLastStep()"
  [customMessage]="customWelcomeMessage()" (completed)="onStepCompleted()"></app-welcome-message>
}

@case (stepTypes.NEW_CHECKOUT_FLOW) {
<app-new-checkout-disclaimer [embedded]="true" (completed)="onStepCompleted()"></app-new-checkout-disclaimer>
}

}

@if (isMultiStep()) {
<div class="signup-onboarding-footer d-flex align-items-center justify-content-between gap-3 mt-3">
  <button type="button" class="btn btn-link p-0 signup-onboarding-back" [class.invisible]="!canGoBack()"
    (click)="back()">
    <i class="fas fa-arrow-left me-1"></i>Back
  </button>
  <div class="signup-onboarding-dots d-flex gap-2" aria-hidden="true">
    @for (step of steps(); track step; let index = $index) {
    <span class="signup-onboarding-dot" [class.is-active]="index === currentIndex()"></span>
    }
  </div>
  <span class="signup-onboarding-progress text-black-50">Step {{ currentIndex() + 1 }} of {{ totalSteps() }}</span>
</div>
}
